module.exports = __webpack_public_path__ + "img/media-30.474e95a7.png";